// routes
import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_HOST_API;
export const HOST_BONUS_API = import.meta.env.VITE_HOST_BONUS_API || HOST_API;
export const ASSETS_API = import.meta.env.VITE_ASSETS_API || '';
export const OPERATOR_ID = import.meta.env.VITE_OPERATOR_ID;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'

// to delete
export const MAPBOX_API = import.meta.env.VITE_MAPBOX_API;
export const AMPLIFY_API = {
  userPoolId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: import.meta.env.VITE_AWS_AMPLIFY_REGION,
};
// export const AUTH0_API = {
//   clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
//   domain: import.meta.env.VITE_AUTH0_DOMAIN,
//   callbackUrl: import.meta.env.VITE_AUTH0_CALLBACK_URL,
// };
export const FIREBASE_API = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};
